import extend from 'extend';
import Utils from 'utils';
const axios = require('axios');

function toFormData(obj, form, namespace) {
  let fd = form || new FormData();
  let formKey;
  
  for(let property in obj) {
    if(obj.hasOwnProperty(property) && obj[property]) {
      if (namespace) {
        formKey = namespace + '[' + property + ']';
      } else {
        formKey = property;
      }
     
      // if the property is an object, but not a File, use recursivity.
      if (obj[property] instanceof Date) {
        fd.append(formKey, obj[property].toISOString());
      }
      else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
        toFormData(obj[property], fd, formKey);
      } else { // if it's a string or a File object
        fd.append(formKey, obj[property]);
      }
    }
  }
  
  return fd;
}

class APIUtils {
  static objectToQuery(obj) {
    let tokens = [];
    for (let name in obj) {
      tokens.push(`${name}=${JSON.stringify(obj[name])}`);
    }
    if (tokens.length > 0) {
      return '?' + tokens.join('&');
    }
    return '';
  }
}

export default class Api {
  static query() {
    return APIUtils.objectToQuery({
      limit: 1,
      query: {
        gcspath: {
          $exists: 1
        },
        timestamp: {
          $lte: Utils.dateToString(new Date())
        }
      },
      filter: {
        timestamp: 1,
        value: 1,
        gcspath: 1,
        gcsthumbpath: 1
      },
      sort: {timestamp: -1}
    });
  }

  

  static uploadFile(opts) {
    const data = toFormData(opts.data);
    return axios.request({
      method: opts.method,
      url: opts.url,
      data,
      headers: {
        Authorization: 'Bearer ' + opts.token,
      },
    });
    
  }

  static request(opts) {
    opts.headers = extend({
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    }, opts.headers)

    if (opts.token) opts.headers.authorization = 'Bearer ' + opts.token
    if (opts.apitoken) opts.headers.authorization = opts.apitoken

    let data = {
      headers: opts.headers,
      method: opts.method || "GET"
    }

    if (opts.body) data.body = JSON.stringify(opts.body);

    // console.log('data.body', data.body)

    return fetch(opts.url, data)
    // Parse JSON
      .then((res) => {
        var contentType = res.headers.get("content-type");
        if (!res.ok) {
          var promise;
          if (contentType && contentType.indexOf("application/json") !== -1) {
            promise = res.json()
          }
          promise = res.text();
          return promise.then((res) => {
            throw new Error(res);
          });
        }

        if (contentType && contentType.indexOf("application/json") !== -1) {
          return res.json();
        }
        if (contentType && contentType.indexOf("text/html") !== -1) {
          return res.text();
        }
        
        return res;
      })
  }
}



// WEBPACK FOOTER //
// ./client/utils/api.js